export const i18n = {
  methods: {
    /* eslint-disable no-undef */
    t: (...args) => I18n.t(...args),
    currentLocale: () => I18n.currentLocale(),
    /* eslint-enable no-undef */
  },
}
